import {FC, useState, createContext, useContext, useCallback} from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../_dashboard/helpers'
import {useLang} from '../../../../../_dashboard/i18n/Metronici18n'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const lang = useLang() || 'fr'
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    language: lang,
  })

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev: QueryState) => ({...prev, ...updates}) as QueryState)
  }, [])

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
